@let score = user().summary?.percentage ?? 0;

<article
  class="bg-blue-primary flex flex-col gap-4 rounded-sm p-4 text-white shadow-[0px_3px_6px_0px_#00000065]"
  [class.cursor-pointer]="link()"
  [class.hover:shadow-lg]="link()"
  [class.transition-shadow]="link()"
  [routerLink]="link() || null">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <span class="text-lg font-semibold italic">{{ user().name | uppercase }}</span>

      <div
        class="bg-gray-slate flex items-center rounded-full px-3 py-1 text-sm shadow-md"
        style="box-shadow: 0px 1px 3.2px 0px #00000040">
        <icon name="helmet-icon" />
        <span class="ml-1">{{ user().totalUsers }}</span>
      </div>
    </div>
    <score [score]="score"></score>
  </div>

  <div class="flex gap-6">
    @if (showAvatar() && user().avatar) {
      <div class="flex h-full">
        <img
          [src]="user().avatar"
          alt="Badge"
          class="size-[100px] rounded-lg object-contain" />
      </div>
    }

    <div class="flex flex-1 flex-col gap-2">
      @for (item of user().kpis; track item.slug) {
        <kpi-details [kpi]="item"></kpi-details>
      }
    </div>
  </div>
</article>
